var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMovie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "146.808px",
    height: "146.808px",
    viewBox: "0 -16.49 146.808 146.808",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "movie_cinema",
    "data-name": "movie cinema",
    transform: "translate(-218.235 -141.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1910",
    "data-name": "Group 1910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1909",
    "data-name": "Group 1909"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1758",
    "data-name": "Rectangle 1758",
    width: 134.47,
    height: 94.997,
    rx: 7.862,
    transform: "translate(226.806 160.171)",
    fill: "#483b44"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4476",
    "data-name": "Path 4476",
    d: "M343.1,207.587a3.521,3.521,0,0,1-3.521,3.522h-89.92a3.521,3.521,0,0,1-3.521-3.522h0a3.521,3.521,0,0,1,3.521-3.521h89.92a3.521,3.521,0,0,1,3.521,3.521Z",
    fill: "#e5eff3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4477",
    "data-name": "Path 4477",
    d: "M343.1,230.19a3.52,3.52,0,0,1-3.521,3.521h-89.92a3.52,3.52,0,0,1-3.521-3.521h0a3.52,3.52,0,0,1,3.521-3.521h89.92a3.52,3.52,0,0,1,3.521,3.521Z",
    fill: "#e5eff3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1912",
    "data-name": "Group 1912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1911",
    "data-name": "Group 1911"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4478",
    "data-name": "Path 4478",
    d: "M365.043,176.485a2.619,2.619,0,0,1-2.621,2.6H225.66a2.621,2.621,0,0,1-2.621-2.6V143.94a2.62,2.62,0,0,1,2.621-2.6H362.422a2.619,2.619,0,0,1,2.621,2.6Z",
    fill: "#e5eff3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4479",
    "data-name": "Path 4479",
    d: "M362.422,141.336H225.66a2.629,2.629,0,0,0-2.621,2.621v16.7h142v-16.7A2.627,2.627,0,0,0,362.422,141.336Z",
    fill: "#e2dfda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4480",
    "data-name": "Path 4480",
    d: "M287.171,141.336H265.878l17.763,19.493-19.325,18.833h21.292l19.325-18.833Zm-61.511,0a2.639,2.639,0,0,0-2.621,2.643v33.04a2.64,2.64,0,0,0,2.621,2.643h18.674l19.324-18.833L245.9,141.336Zm136.762,0h-15.96l17.762,19.493L344.9,179.662h17.523a2.639,2.639,0,0,0,2.621-2.643v-33.04A2.638,2.638,0,0,0,362.422,141.336Zm-56.907,0,17.762,19.493-19.324,18.833h21.292l19.324-18.833-17.761-19.493Z",
    fill: "#483b44"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1914",
    "data-name": "Group 1914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1913",
    "data-name": "Group 1913"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4481",
    "data-name": "Path 4481",
    d: "M248.361,158.448a3.9,3.9,0,0,1-.608,4.21L230.32,180.724a7.092,7.092,0,0,1-4.441,1.886h-5.023a2.628,2.628,0,0,1-2.621-2.62V148.323a2.627,2.627,0,0,1,2.621-2.619H239.09a4.764,4.764,0,0,1,3.834,2.322Z",
    fill: "#e2dfda"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4482",
    "data-name": "Path 4482",
    d: "M235.487,162.628a4.8,4.8,0,1,1-4.8-4.8A4.8,4.8,0,0,1,235.487,162.628Z",
    fill: "#483b44"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.8fa29109.svg";
export { ForwardRef as ReactComponent };